import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MembershipSpecializationService } from '../services/membership.specialization.service';
import { MembershipSpecialization } from '../models/membership.specialization.model';
import { NotificationService } from '../services/notification.service';
import { LookupService } from '../services/lookup.service';

@Component({
  selector: 'app-membership-specialization-form',
  templateUrl: './membership-specialization-form.component.html'
})
export class MembershipSpecializationFormComponent {
  constructor(public lookupService: LookupService, public service: MembershipSpecializationService, private notificationService: NotificationService) { }

  @Input() model: MembershipSpecialization;

  submitted = false;

  ngOnInit() {
    this.lookupService.getSpecializations();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;

    if (!this.model.membershipSpecializationID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.model.specializationID = null;
        this.model.copayment = null;
        this.service.search();

        $('#PanelForm').slideToggle();
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.service.search();

        $('#PanelForm').slideToggle();
      },
      err => {
        console.log(err);
      }
    )
  }
}

